<template>
  <div>
    <a href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/rerunFluence.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <br/>
    <b-form @submit="rerunIntensityCalibration">
      <h5>Basic Parameters:</h5>
        <p>Only enter values in the fields below if you want to extend the left and right window. If you just want to rerun the fluence pipeline because you re-ran fitburst, just submit it without any values in the fields.</p>
        <b-form-group label-cols="4" label="Extend Window Left (bins):" label-for="window_left_input">
          <b-form-input label-cols="4" label="Extend Window Left (bins):" id="window_left_input" v-model="intensityCalibrationForm.extend_window_left"/>
        </b-form-group>
        <b-form-group label-cols="4" label="Extend Window Right (bins):" label-for="window_right_input">
          <b-form-input label-cols="4" label="Extend Window Right (bins):" id="window_right_input" v-model="intensityCalibrationForm.extend_window_right"/>
        </b-form-group>
    </b-form>
  </div>
</template>

<script>
export default{
  props: [
    'rerunIntensityCalibration',
    'intensityCalibrationForm'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/rerunFluence.vue